export enum MonitoringFrequency {
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  QUARTERLY = "Quarterly",
  SEMI_ANNUALLY = "Semiannually",
  ANNUALLY = "Annually",
}
